// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class MedBenEnrollmentUpdateRequestModel {
    static getAttributeTypeMap() {
        return MedBenEnrollmentUpdateRequestModel.attributeTypeMap;
    }
}
MedBenEnrollmentUpdateRequestModel.discriminator = undefined;
MedBenEnrollmentUpdateRequestModel.attributeTypeMap = [
    {
        "name": "clientIdentifiers",
        "baseName": "clientIdentifiers",
        "type": "EnrollmentMedBenClientIdentifiersModel"
    },
    {
        "name": "demographics",
        "baseName": "demographics",
        "type": "MedBenEnrollmentDemographicsModel"
    },
    {
        "name": "guardianInfo",
        "baseName": "guardianInfo",
        "type": "EnrollmentGuardianInfoModel"
    }
];
//# sourceMappingURL=medBenEnrollmentUpdateRequestModel.js.map